Ext.define('SA.data.CounterpartAttributeType', {
    statics: {
        create(params) {
            return new SA.data.CounterpartAttributeType(params);
        }
    },

    constructor({stringValue, symbol}) {
        this.ownStringValue = stringValue;
        this.ownSymbol = symbol;

        this.counterpartType = null;
    },

    counterpart() {
        return this.counterpartType;
    },

    hasStringValue(stringValue) {
        return stringValue === this.stringValue();
    },

    hasSymbol(symbol) {
        return symbol === this.ownSymbol;
    },

    setCounterpart(counterpart) {
        this.counterpartType = counterpart;
    },

    stringValue() {
        return this.ownStringValue;
    },

    symbol() {
        return this.ownSymbol;
    }
});